import React from 'react';
import './../index.css';

export class LevelNav extends React.Component {
  componentDidMount() {
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }
  render() {
    const parentIndex = this.props.parentIndex;
    const parentTitle = this.props.parentTitle;
    return (
      <>
        {
          /* 
           * back, home navigation
           */
        }
        <div>
          <table className='navTable'>
            <tbody>
              <tr>
                {
                  '0.' !== parentIndex
                    ?
                    <td className='backNav'>
                      <button className='parentButton' onClick={() => this.props.onLevelClick(parentIndex)}>
                        {'< Back to: ' + parentTitle}
                      </button>
                    </td>
                    :
                    <td />
                }
                {
                  '-1' !== this.props.searchValue
                    ?
                    <td className='searchBox'>
                      <div className='searchWrapper'>
                        <label htmlFor='search'>
                          Search:
                        </label>
                        <input
                          ref={inputEl => (this.searchInput = inputEl)}
                          name="search"
                          type="text"
                          value={this.props.searchValue}
                          onChange={(event) => this.props.searchChange(event)}
                          autoComplete='off' />
                      </div>
                    </td>
                    :
                    <td />
                }
                {
                  '0.' !== parentIndex
                    ?
                    <td className='homeNav'>
                      <button className='parentButton' onClick={() => this.props.onLevelClick('1')}>
                        {'Home'}
                      </button>
                    </td>
                    :
                    <td />
                }
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }
}
